import {Component, HostListener, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {EMPTY, Observable} from 'rxjs';
import {Client, ClientUpsertRequest, Person} from '../../api/model/client';
import {ClientService} from '../../api/client.service';
import {apiErrorToMessage} from '../../common/util';

export interface ClientEditDialogData {
  client: Client;
}

@Component({
  selector: 'app-client-edit-dialog',
  templateUrl: './client-edit-dialog.component.html',
  styleUrls: ['./client-edit-dialog.component.sass'],
})
export class ClientEditDialogComponent {
  apiError: string | undefined;
  editForm: FormGroup;

  constructor(
    private clientService: ClientService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ClientEditDialogComponent, Client | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: ClientEditDialogData,
  ) {
    dialogRef.disableClose = true;
    this.editForm = this.fb.group({
      people: this.fb.array(data.client.people.map(p => this.makePersonForm(p))),
    });
  }

  get people(): FormArray<FormGroup> {
    return this.editForm.controls['people'] as FormArray<FormGroup>;
  }

  addPerson() {
    this.people.push(this.makePersonForm());
    this.editForm.markAsDirty();
  }

  removePerson(i: number) {
    this.people.removeAt(i);
    this.editForm.markAsDirty();
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.onCancelClick();
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.editForm.dirty;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    this.apiError = undefined;
    const request: ClientUpsertRequest = {
      name: this.data.client.name,
      people: this.people.getRawValue() as Person[],
    };
    this.clientService.update(this.data.client.id, request).subscribe({
      next: client => this.dialogRef.close(client),
      error: err => {
        console.log("ClientEditDialog onSaveClick error", err);
        this.apiError = apiErrorToMessage(err);
        return EMPTY;
      },
    });
  }

  private makePersonForm(p?: Person): FormGroup {
    return this.fb.group({
      name: [p?.name ?? null],
      phone: [p?.phone ?? null],
      email: [p?.email ?? null],
    });
  }
}
